import React,{useState,useEffect}  from 'react'
import {Database} from "./Firebase/Firebase"
import {Container, Row, Col,Button,Badge,Form } from "react-bootstrap";
import {Link} from "react-router-dom";
import useLocalStorage from "./LocaleStorage/UseLocaleStorage";
import NavBar from "./NavBar";
import Footer from "./Footer";
const Lunettes = () => {
    const [articleToSend,setArticleToSend]=useLocalStorage("Article");
    const [articleLunettese,setArticleLunettese]=useState([]);
    useEffect(()=>{
        ReadDataFromDatabaseLunettes();
    },[])
    const ReadDataFromDatabaseLunettes = ()=>{
        const articleLunettes = Database.database().ref("Lunettes")
        articleLunettes.on("value",(snapShot)=>{
          const data= snapShot.val();
          let  list = [];
            for( let id in data)
             {
               list.push({id,...data[id]})
             }
             setArticleLunettese(list)
        })
    }
    return (
        <>
        <NavBar/>
                <Container>
                    <h2 className="section__title text-center title__woman">Lunnetes</h2>
                    <h6 className=" section__title Subtitle">إضغط (ي) على المنتج لمزيد من معلومات حوله</h6>
                    <Row>
                              {articleLunettese.map((Glass)=>(
                                <Col key={Glass.id} lg={4} md={6} sm={6} xs={4} className="featured__product">
                                     <Link onClick={()=>setArticleToSend(Glass)} to={`/Confirmation/:${Glass.id}`} className="Cardhover">
                                <div className="cardF">
                                    <div className="featured__box">
                                        <Badge className="featured__new">Promo</Badge>
                                        <img src={Glass.urlToUse} className="featured__img" alt="Product"/>
                                    </div>
                                    <div className="featured__data">
                                        <h3 className="featured__name">{Glass.name}</h3>
                                        <span className="text-center underLine">{`${(Glass.prix*1.5)} DH`}</span>        
                                        <span className="featured_preci">
                                            {`${Glass.prix} DH`}
                                        </span>
                                        
                                        <Link className="buttonComanderLink" to={`/Confirmation/:${Glass.id}`}>
                                            <Button onClick={()=>setArticleToSend(Glass)} className="buttonComander text-center buttonComanderLinke" variant="primary">                                             
                                                        Commander
                                            </Button>
                                        </Link> 
                                    </div>
                                </div>
                                </Link>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                    <Footer/>
        </>
    )
}

export default Lunettes
